import { cva } from 'class-variance-authority';

export const flag = cva(
  'text-color-text-light absolute font-bold [-webkit-text-stroke:1px_rgba(0,0,0,1)]',
  {
    variants: {
      size: {
        large: 'text-size-body-2xl ml-2',
        medium: 'text-size-body-lg ml-[13px]',
        small: 'text-size-body-sm ml-1.5',
      },
    },
    defaultVariants: { size: 'medium' },
  },
);
